import { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { useRegionContext } from '../context/RegionContext';
import { ExternallyControlledDialog } from './dialogs';

function AccessCodeDialog({ onSuccess, accessCode, open }) {
    const [inputCode, setInputCode] = useState('');
    const [error, setError] = useState(false);

    const validateCode = () => {
        if (inputCode === accessCode) {
            onSuccess();
        } else {
            setError(true);
        }
    };

    useEffect(() => {
        setError(false);
    }, [inputCode]);

    return (
        <ExternallyControlledDialog title="Voor deze regio is een toegangscode vereist" open={open}>
            <TextField
                error={error}
                label="Toegangscode"
                value={inputCode}
                onChange={e => setInputCode(e.target.value)}
                fullWidth
                helperText={error ? 'Onjuiste toegangscode, probeer het opnieuw.' : null}
                sx={{
                    mt: 1,
                    mb: 1,
                    '& .MuiInputBase-input': {
                        textAlign: 'center',
                        letterSpacing: '0.2em'
                    }
                }}
            />
            <Button sx={{ width: '100%' }} variant="contained" onClick={validateCode}>
                Valideer
            </Button>
        </ExternallyControlledDialog>
    );
}

function RegionAccessCode({ children }) {
    const { region, regionData } = useRegionContext();
    const [hasProvidedCorrectAccessCode, setHasProvidedCorrectAccessCode] = useState(false);

    useEffect(() => {
        setHasProvidedCorrectAccessCode(false);
    }, [region]);

    return (
        <>
            <AccessCodeDialog
                onSuccess={() => setHasProvidedCorrectAccessCode(true)}
                accessCode={regionData ? regionData.access_code : null}
                // Only display the dialog if the region has an access code and the user hasn't provided it yet
                open={regionData && !!regionData.access_code && !hasProvidedCorrectAccessCode}
            />
            {children}
        </>
    );
}

export default RegionAccessCode;
